import { jsx } from "react/jsx-runtime";
import "react";
import { ChatUIContext } from "./ChatUIContext.js";
const ChatUIContextProvider = ({ children, value })=>/*#__PURE__*/ jsx(ChatUIContext.Provider, {
        value: value,
        children: children
    });
export { ChatUIContextProvider };
